/**
 * The pawns a player has left to place.
 *
 * A king that captures gains one (§3), so this counts down and back up during a game and
 * is worth showing as a row of pieces rather than a number: the difference between two
 * spawns and six is a strategic fact you should be able to take in without reading.
 */

import { PieceTile } from './Pieces.tsx';

export function Reserve({
  count,
  player,
  selected,
  onPick,
}: {
  count: number;
  player: 0 | 1;
  selected: boolean;
  onPick?: () => void;
}) {
  const shown = Math.min(count, 8);
  const interactive = Boolean(onPick) && count > 0;

  return (
    <button
      type='button'
      disabled={!interactive}
      onClick={onPick}
      aria-pressed={selected}
      aria-label={`${count} pawns in reserve${interactive ? ', place one' : ''}`}
      className={`flex w-full items-center gap-2 rounded-md border px-2 py-1.5 transition-colors
        ${
        selected
          ? 'border-accent bg-accent-soft'
          : 'border-transparent hover:border-rule disabled:hover:border-transparent'
      }
        ${interactive ? 'cursor-pointer' : 'cursor-default'}`}
    >
      <span className='flex -space-x-1.5'>
        {Array.from(
          { length: shown },
          (_, i) => (
            <svg key={i} viewBox='-1 -1 2 2' className='size-4 shrink-0'>
              <PieceTile king={false} player={player} scale={0.9} />
            </svg>
          ),
        )}
        {shown === 0 && <span className='text-xs text-muted'>none</span>}
      </span>
      <span className='tabular ml-auto font-mono text-xs text-muted'>
        {count}
      </span>
    </button>
  );
}
